import DataPill from "@components/pills/DataPill";
import React from "react";

interface StatusPillBankManagementProps {
  statusText: string;
}

const StatusPillBankManagement: React.FC<StatusPillBankManagementProps> = ({
  statusText,
}) => {
  return <DataPill value={statusText} label={statusText} />;
};

export default StatusPillBankManagement;
